import { makeRules } from "../rules/makeRules";
import { RuleSet } from "../rules/ruleSet";

// https://en.wikipedia.org/wiki/Chain_shift
export const chainShiftRules: Record<string, RuleSet> = {
  "Grimm's Law":
    { rules: makeRules([['bʱ', 'b', 'p', 'f'], ['dʱ', 'd', 't', 'θ'], ['ɡʱ', 'ɡ', 'k', 'h']], true) },
  "High German Consonant Shift":
    { rules: makeRules([['d', 't', 'ts'], ['ɡ', 'k', 'kx'], ['b', 'p', 'pf']], true) },
}
